import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.EXECUTIVE_SUMMARY}.${BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.COMPANY_DESCRIPTION}` as const;

export const EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES = {
  HISTORY: 'history',
  RESOURCES_AND_ASSETS: 'resourcesAndAssets',
  COMPANY_OWNERS: 'companyOwners',
} as const;

export interface ICompanyDescriptionExecutiveSummaryForm {
  [EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES.HISTORY]: string;
  [EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES.RESOURCES_AND_ASSETS]: string;
  [EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES.COMPANY_OWNERS]: string;
}

export const companyDescriptionExecutiveSummaryInitialValues: ICompanyDescriptionExecutiveSummaryForm = {
  [EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES.HISTORY]: '',
  [EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES.RESOURCES_AND_ASSETS]: '',
  [EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES.COMPANY_OWNERS]: '',
};
